import { useState } from "react";
import { Languages, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr as errMsg } from "@/lib/api";

const LANG = (navigator.language || "de").slice(0, 2).toLowerCase();

export function TranslateButton({ text, testId, onText }) {
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  if (LANG === "de" || !text?.trim()) return null;
  const go = async () => {
    if (done) { onText(null); setDone(false); return; }
    setBusy(true);
    try { onText((await api.post("/ai/translate", { text, lang: LANG })).data.text); setDone(true); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <button type="button" onClick={go} disabled={busy} data-testid={testId} className="inline-flex items-center gap-1 text-xs font-semibold text-sky-600 hover:underline disabled:opacity-60">
      {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Languages className="w-3 h-3" />} {done ? "Original" : "Übersetzen"}
    </button>
  );
}
